__turbopack_context__.v({
  "className": "parkinsans_ae2fdd89-module__IYA7PW__className",
  "variable": "parkinsans_ae2fdd89-module__IYA7PW__variable",
});
